import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useSelector } from 'react-redux';
import styles from './footerNav.module.scss';
import defaultLang from '../../language';

function FooterNav({ allProducts }) {
    const composedClass = allProducts ? 'all-products' : '';
    const AEMContent = useSelector(
        (state) => state.AEMContentReducer.AEMContent,
    );
    return (
        <>
            <nav
                className={`${styles['footer-nav']} ${styles[composedClass]}`}
            >
                <div>
                    <div className="disclosureTitle">
                        {AEMContent?.prodRecBusinessBankDisclousers
                            ?.disclosureTitle ||
                            defaultLang.prodRecBusinessBankDisclousers
                                .disclosureTitle}
                    </div>
                    <div>
                        {ReactHtmlParser(
                            AEMContent?.prodRecBusinessBankDisclousers
                                ?.disclosureContent ||
                                defaultLang
                                    .prodRecBusinessBankDisclousers
                                    .disclosureContent,
                        )}
                    </div>
                    <div>
                        {ReactHtmlParser(
                            AEMContent?.prodRecBusinessBankDisclousers
                                ?.disclosureList ||
                                defaultLang
                                    .prodRecBusinessBankDisclousers
                                    .disclosureList,
                        )}
                    </div>
                </div>
            </nav>
        </>
    );
}

export default FooterNav;
